<div class="hidden-layer" [hidden]="!state.gridLoading">
  <mat-progress-bar mode="indeterminate" class="w-full"></mat-progress-bar>
</div>
<ag-grid-angular
  #agGrid
  class="ag-theme-material-datos"
  [gridOptions]="gridOptions"
  [components]="frameworkComponents"
  [columnDefs]="columnDefs"
  [rowData]="logs"
  (columnResized)="onColumnResized()"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>
